import childrenComponentTpl from './views/childrenComponent.html';
import childrenComponentCtrl from './controller/childrenComponentController';
import './parentPortal.scss';

export default angular.module('childrenComponentModule', [])
  .component('childrenComponent', {
    template: childrenComponentTpl,
    controllerAs: 'childrenComponent',
    controller: childrenComponentCtrl
  })
  .config(function ($stateProvider) {
    'ngInject'
    $stateProvider.state('childrenComponent', {
      parent: 'app',
      url: '/children-component',
      template: '<children-component></children-component>'
    })
  })
  .constant('CHILDREN_COMPONENT_CONSTANTS', {
    API_GET_PARENT_DETAILS: "/v0/parent/portal/person/details/",
    API_GET_PARENT_CHILD_DETAILS: "/v0/parent/portal/child/details/",
  });


// WEBPACK FOOTER //
// ./src/app/parent-portal/childrenComponentModule.js